import React from "react";
import './Experience.scss'
import {Link} from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import {EXPERIENCE} from "../helper/constant";

const Experience = ()=>{

    return(
        <>
            <div className={'goBack'}><Link to={'/'}><HomeIcon className={'back'}/></Link></div>

            <div className={'experienceContainer'}>
                <div className={'insideContainer'}>
                    <h1>Working Experience</h1>
                    <h2>{EXPERIENCE.FIRST_POSITION}</h2>
                    <div>{EXPERIENCE.FIRST_DETAILS}</div>
                    <div>{EXPERIENCE.DETAIL_TITLE}</div>
                    <div>{EXPERIENCE.FIRST_PROJECT}</div>
                    <div>{EXPERIENCE.SEC_PROJECT}</div>
                    <h2>{EXPERIENCE.SEC_POSITION}</h2>
                    <div>{EXPERIENCE.SEC_TITLE}</div>
                    <div>{EXPERIENCE.SEC_DETAILS}</div>
                </div>
            </div>
        </>

    )
}



export default Experience
